import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "../../ui/dialog";
import React, { useState } from "react";
import Button from "../../form/button";
import ErrorMessage from "../../form/errorMessage";
import { IExpenseList, Status } from "../../../lib/types";
import { Input } from "../../ui/input";
import pb from "../../../lib/pocketbase";
import { useNavigate } from "react-router-dom";

interface NewListProps {
    children: React.ReactNode;
}

export default function NewList({ children }: NewListProps) {
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [open, setOpen] = useState(false);
    const [error, setError] = useState("");
    const [status, setStatus] = useState<Status>("none");

    function add() {
        if (!pb.authStore.model) return;
        setStatus("loading");
        const data: IExpenseList = {
            name: name,
            user: pb.authStore.model.id,
            public: false,
            archive: false
        };

        pb.collection("expenseList")
            .create(data)
            .then((x) => {
                setTimeout(() => {
                    setStatus("success");
                    setError("");
                    setOpen(false);
                    navigate(`/studio/expenses/list/${x.id}`);
                }, 500);
            })
            .catch((err: Error) => {
                setStatus("error");
                setError(err.message);
            })
            .finally(() => {
                setTimeout(() => {
                    setStatus("none");
                }, 3000);
            });
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>{children}</DialogTrigger>
            <DialogContent className="mt-8 md:mt-0">
                <DialogHeader>
                    <DialogTitle>New list</DialogTitle>
                </DialogHeader>
                <ErrorMessage error={error} close={() => setError("")} />
                <Input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="List name" />
                <DialogFooter className="gap-2">
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button status={status} onClick={() => add()} variant="dark">
                        {status === "loading" && "Adding"}
                        {status === "success" && "Added"}
                        {status === "error" && "Error"}
                        {status === "none" && "Add"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
